// extracted by mini-css-extract-plugin
module.exports = {"infoSection":"styles_infoSection__2S19y","subtitle":"styles_subtitle__3vDqa","content":"styles_content__1Mg2i","title":"styles_title__2zrQk"};